export default `<div class="autocomplete">
    <div class="autocomplete-input-wrapper">
        <input
            id="autocomplete-input"
            class="autocomplete-input"
            type="text"
            placeholder=" "
            role="combobox"
            autocomplete="off"
            spellcheck="false"
            aria-describedby="autocomplete-assistive-label"
            aria-autocomplete="list"
            aria-expanded="false"
            aria-controls="autocomplete-list"
            part="input"
        />
        <label for="autocomplete-input"></label>
        <slot name="icon"></slot>
    </div>
    <span id="autocomplete-assistive-label" class="hidden">
        When autocomplete results are available use the up and down arrow keys
        to navigate the list. Press enter to select an option.
    </span>
    <div class="autocomplete-dropdown hidden" part="dropdown">
        <ul
            id="autocomplete-list"
            class="autocomplete-list"
            aria-describedby="autocomplete-assistive-label"
            role="listbox"
            part="list"
        ></ul>
        <slot name="list-footer" class="hidden"></slot>
    </div>
    <div
        class="autocomplete-live-region sr-only"
        role="status"
        aria-live="polite"
        aria-atomic="true"
    ></div>
</div>

<style>
    :host {
        display: block;
        position: relative;
        width: 100%;
        font-family: Asap, sans-serif;
    }

    .autocomplete {
        position: relative;
    }

    .autocomplete-input {
        background-color: var(--svea-input-background, #ffffff);
        color: var(--svea--input-color, #434343);
        height: var(--svea-input-height, 3.5rem);
        padding: var(--svea-input-padding, 0.5rem 0.5rem 0.5rem 1.25rem);
        border: var(--svea-input-border, 1px solid #949494);
        border-radius: var(--svea-input-border-radius, 0.5rem);
        font-size: var(--svea-input-font-size, 1rem);
        font-weight: var(--svea-input-font-weight, 500);
        line-height: var(--svea-input-line-height, 1.5rem);
        box-sizing: border-box;
        width: 100%;
    }

    .autocomplete-input:has(+ .floating-label) {
        padding: var(
            --svea-input-padding-floating-label,
            1.5rem 0.5rem 0.5rem 1.25rem
        );
    }

    .autocomplete-input:hover {
        border-color: var(--svea-input-border-color-hover, #146790);
    }

    .autocomplete-input:focus {
        border: none;
        outline: var(--svea-input-outline-focus, 2px solid #146790);
    }

    .autocomplete-input::placeholder {
        color: var(--svea-input-placeholder-color, #212529bf);
    }

    .autocomplete-input:has(+ .floating-label)::placeholder {
        color: transparent;
    }

    .autocomplete-input:disabled {
        background-color: var(--svea-input-background-disabled, #f6f6f1);
        color: var(--svea-input-color-disabled, #949494);
        border-color: var(--svea-input-border-color-disabled, #949494);
        cursor: not-allowed;
    }

    .autocomplete-input:disabled + .floating-label {
        color: var(--svea-input-color-disabled, #949494);
    }

    .autocomplete-input + .floating-label {
        position: absolute;
        left: 1.25rem;
        top: 50%;
        transform: translateY(-50%);
        color: var(--svea-input-label-text, #434343);
        pointer-events: none;
        transition: all 0.2s ease-out;
        background-color: transparent;
    }

    .autocomplete-input:focus + .floating-label,
    .autocomplete-input:not(:placeholder-shown) + .floating-label {
        top: 1rem;
        font-size: 0.75rem;
        line-height: 1rem;
        transform: translateY(-50%);
    }

    .autocomplete-input-wrapper {
        position: relative;
    }

    .autocomplete-input-wrapper::slotted([slot='icon']) {
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
    }

    .autocomplete-dropdown {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        margin-top: 0.25rem;
        padding: 0.5rem;
        width: 100%;
        border-radius: var(--svea-input-border-radius, 0.5rem);
        box-sizing: border-box;
        z-index: 1000;
        background-color: var(--svea-dropdown-background, #ffffff);
        max-height: var(--svea-dropdown-max-height, 15rem);
        box-shadow:
            0px 5px 12px 0px #0000001f,
            0px 0px 1px 0px #00000047;
        overflow-y: auto;
    }

    .autocomplete-list {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .autocomplete-item {
        padding: 0.5rem 1rem;
        border-radius: 0.25rem;
    }

    .autocomplete-item:focus-visible {
        outline: var(
            --svea-autocomplete-item-border-focus-color,
            2px solid #00699a
        );
    }

    .autocomplete-item:hover {
        background-color: var(--svea-dropdown-item-hover-background, #00699a0d);
        cursor: pointer;
    }

    .autocomplete-item[aria-selected='true'] {
        background-color: var(
            --svea-dropdown-item-selected-background,
            #e8f6f9
        );
    }

    .hidden {
        display: none;
    }

    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
    }
</style>
`